/* script */
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import PlayImage  from '@/components/elements/PlayImage.vue';
import Equalizer from '@/components/elements/Equalizer.vue';
import bus from '@/bus.js';
import { store }   from '@/store';

const __vue_script__ = {
	data() {
		return {
			strings: ui_data.strings
		}
	},
	props: {
        featuredMusic: Array,
        featuredBeatsHeadline: String,
		featuredGenres: Array, 
		featuredMoods: Array,
	},
	methods: {
		updateSong( index, id ) {
			let vm = this;
			bus.$emit( 'updatePlaylist', vm.audioSources );
			bus.$emit( 'updateSong', index, id );
			this.$store.commit( 'updateSongID', id);
		},
	},
	components: {
		PlayImage,
		Equalizer,
	},
	computed: {
		songID () {
			return this.$store.getters.getSongID;
		},
		playingStatus () {
		 	return this.$store.getters.getPlayingStatus;
		},
	},
};

/* template */
var __vue_render__ = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.featuredMusic && _vm.featuredMusic.length > 0)?_c('div',{staticClass:"featured-beats"},[_c('h2',{domProps:{"innerHTML":_vm._s(_vm.featuredBeatsHeadline)}}),_vm._v(" "),_c('div',{staticClass:"container"},[_vm._l((_vm.featuredGenres),function(genre){return _c('div',{key:genre.slug,staticClass:"beat"},[_c('router-link',{staticClass:"title",attrs:{"to":{ name: 'genre', params: { genre: genre.slug }}}},[_c('div',{staticClass:"image_grid--container"},[_c('picture',[_c('source',{attrs:{"media":"(min-width: 768px)","srcset":genre.image}}),_vm._v(" "),_c('source',{attrs:{"media":"(min-width: 1201px)","srcset":genre.image}}),_vm._v(" "),_c('img',{directives:[{name:"lazy",rawName:"v-lazy",value:(genre.image),expression:"genre.image"}],staticClass:"featured-image",attrs:{"alt":genre.slug,"width":"180","height":"180"}})])]),_vm._v(" "),_c('span',{domProps:{"innerHTML":_vm._s(genre.title)}})])],1)}),_vm._v(" "),_vm._l((_vm.featuredMoods),function(mood){return _c('div',{key:mood.slug,staticClass:"beat"},[_c('router-link',{staticClass:"title",attrs:{"to":{ name: 'mood', params: { mood: mood.slug }}}},[_c('div',{staticClass:"image_grid--container"},[_c('picture',[_c('source',{attrs:{"media":"(min-width: 768px)","srcset":mood.image}}),_vm._v(" "),_c('source',{attrs:{"media":"(min-width: 1201px)","srcset":mood.image}}),_vm._v(" "),_c('img',{directives:[{name:"lazy",rawName:"v-lazy",value:(mood.image),expression:"mood.image"}],staticClass:"featured-image",attrs:{"alt":mood.slug,"width":"180","height":"180"}})])]),_vm._v(" "),_c('span',{domProps:{"innerHTML":_vm._s(mood.title)}})])],1)}),_vm._v(" "),_vm._l((_vm.featuredMusic),function(product){return _c('div',{key:product.id,staticClass:"beat"},[_c('div',{staticClass:"image_grid--container",on:{"click":function($event){return _vm.updateSong( product.index, product.id )}}},[_c('picture',[_c('source',{attrs:{"media":"(min-width: 768px)","srcset":product.image_grid_medium}}),_vm._v(" "),_c('source',{attrs:{"media":"(min-width: 1201px)","srcset":product.image_grid}}),_vm._v(" "),_c('img',{directives:[{name:"lazy",rawName:"v-lazy",value:(product.image_grid),expression:"product.image_grid"}],staticClass:"featured-image",attrs:{"alt":product.title,"width":"180","height":"180"}})]),_vm._v(" "),_c('div',{staticClass:"play-button"},[_c('PlayImage')],1),_vm._v(" "),(product.id == _vm.songID && _vm.playingStatus == true)?[_c('Equalizer')]:_vm._e()],2),_vm._v(" "),_c('div',{staticClass:"beat__details"},[_c('router-link',{staticClass:"title",attrs:{"to":product.path},domProps:{"innerHTML":_vm._s(product.title)}}),_vm._v(" "),(product.genre)?_c('p',{staticClass:"featured-beat__genre",domProps:{"innerHTML":_vm._s(product.genre[0])}}):_vm._e()],1)])})],2)]):_vm._e()}
var __vue_staticRenderFns__ = []

  /* style */
  const __vue_inject_styles__ = undefined
  /* scoped */
  const __vue_scope_id__ = undefined
  /* module identifier */
  const __vue_module_identifier__ = undefined
  /* functional template */
  const __vue_is_functional_template__ = false
  /* component normalizer */
  function __vue_normalize__(
    template, style, script,
    scope, functional, moduleIdentifier, shadowMode,
    createInjector, createInjectorSSR, createInjectorShadow
  ) {
    const component = (typeof script === 'function' ? script.options : script) || {}

    // For security concerns, we use only base name in production mode.
    component.__file = "FeaturedBeats.vue"

    if (!component.render) {
      component.render = template.render
      component.staticRenderFns = template.staticRenderFns
      component._compiled = true

      if (functional) component.functional = true
    }

    component._scopeId = scope

    if (false) {
      let hook
      if (false) {
        // In SSR.
        hook = function(context) {
          // 2.3 injection
          context =
            context || // cached call
            (this.$vnode && this.$vnode.ssrContext) || // stateful
            (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext) // functional
          // 2.2 with runInNewContext: true
          if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
            context = __VUE_SSR_CONTEXT__
          }
          // inject component styles
          if (style) {
            style.call(this, createInjectorSSR(context))
          }
          // register component module identifier for async chunk inference
          if (context && context._registeredComponents) {
            context._registeredComponents.add(moduleIdentifier)
          }
        }
        // used by ssr in case component is cached and beforeCreate
        // never gets called
        component._ssrRegister = hook
      }
      else if (style) {
        hook = shadowMode 
          ? function(context) {
              style.call(this, createInjectorShadow(context, this.$root.$options.shadowRoot))
            }
          : function(context) {
              style.call(this, createInjector(context))
            }
      }

      if (hook !== undefined) {
        if (component.functional) {
          // register for functional component in vue file
          const originalRender = component.render
          component.render = function renderWithStyleInjection(h, context) {
            hook.call(context)
            return originalRender(h, context)
          }
        } else {
          // inject component registration as beforeCreate hook
          const existing = component.beforeCreate
          component.beforeCreate = existing ? [].concat(existing, hook) : [hook]
        }
      }
    }

    return component
  }
  /* style inject */
  
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__ = /*#__PURE__*/__vue_normalize__(
    { render: __vue_render__, staticRenderFns: __vue_staticRenderFns__ },
    __vue_inject_styles__,
    __vue_script__,
    __vue_scope_id__,
    __vue_is_functional_template__,
    __vue_module_identifier__,
    false,
    undefined,
    undefined,
    undefined
  )

  export default __vue_component__